import classNames from "classnames";
import { useNavigate } from 'react-router-dom'
import { getContrastColor } from '../../services/stringServices';

function CategoryOption ({to, editTo, category, children, className, activeClassName, handleOptionSelection, selected}){
    const navigate = useNavigate();
    const classes = classNames(
        'text-black', 
        className,
        selected === to && activeClassName
    );


    const handleClick = (event) => {
        if(event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        handleOptionSelection(to)
        navigate(to)
    }
    //,color: `${category.color}`
    return (
        <div className="flex flex-row mt-4 text-lg">
            <div className="w-[35px] h-[30px] rounded-full font-bold text-center" style={{ backgroundColor: `${category.color}`, color: getContrastColor(category.color) }}>
                {category.projectsCount}
            </div>
            
            <div className="ml-2 w-full">
                <a className={classes} href={to} onClick={handleClick}>{category.name}</a>
            </div>
        </div>
    )
}

export default CategoryOption